export default __webpack_public_path__ + "static/media/file-tender-public.6985331c.svg";